const checkButtonsInterval = setInterval(() => {
  const btnCheckouts = document.querySelectorAll('[href="/checkout"], [name="checkout"]');

  if (btnCheckouts.length > 0) {
    btnCheckouts.forEach((btn) => {
      const disableButton = () => {
        btn.disabled = true;
        btn.style.setProperty("pointer-events", "none", "important");
      };

      btn.addEventListener("click", disableButton);
      btn.addEventListener("dblclick", disableButton);
    });

    clearInterval(checkButtonsInterval);
  }
}, 300); 

setTimeout(() => {
    clearInterval(checkButtonsInterval)
}, 10000);